import { defaultOptions } from "../global/slick-options";
import { splitCharacters } from "../utilities/splitCharacters";

jQuery(".staggered-section .staggered-slider").slick({
    ...defaultOptions,
    dots: true,
    appendDots: jQuery('.staggered-dots'),
    slidesToShow: 1,
    arrows: false,
    // infinite: true,
    // speed: 300,
    // arrows: false,
    // dots: true,
    // autoplay: true,
    // autoplaySpeed: 4000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
}).on('afterChange', function (event, slick, currentSlide, nextSlide) {
    var $currentSlideDom = jQuery(slick.$slides.get(currentSlide));
    var $heading = $currentSlideDom.find('[data-handwriting]'); 
    console.log($heading);
    $heading.attr('data-aos', "");

    const heading = $heading.get(0);

    splitCharacters(heading);

    heading.classList.add('aos-animate');
});

jQuery(".staggered-section .images").slick({
    ...defaultOptions,
    // dots: false,
    // infinite: true,
    // speed: 300,
    // slidesToShow: 3,
    // slidesToScroll: 1,
    // arrows: false,
    // autoplay: true,
    // autoplaySpeed: 4000,
    // responsive: [
    //     {
    //         breakpoint: 1024,
    //         settings: {
    //             slidesToShow: 2
    //         }
    //     },
    // ]
});

jQuery("[data-play-video]").on("click", function (e) {
    e.preventDefault();
    var video = jQuery(this).siblings("video");
    jQuery(video).get(0).play();
    jQuery(video).attr("controls", true);
    jQuery(this).fadeOut();
});
